import React, {CSSProperties, FunctionComponent} from "react"
import "./UtilsStyles.scss"
import {Link as RouterLink} from "react-router-dom";

export type UlLinkProps = {
  children?: React.ReactNode,
  link: string,
  newTab?: boolean
  text?: string | any,
  style?: CSSProperties,
  // Internal links navigate client-side by default; pass true for a full document load
  reloadDocument?: boolean,
  noRouterLink?: boolean
}

const UlLink: FunctionComponent<UlLinkProps> = (ulLinkProps) => {
  const {
    link,
    text,
    style,
    newTab,
    reloadDocument = false,
    noRouterLink,
    children,
  } = ulLinkProps;
  const displayText = text === undefined ? (children === undefined ? link : children) : text
  const isFullUrl = link.startsWith("http");

  if (isFullUrl || newTab || noRouterLink) {
    return <a className="UlLinks"
              href={link}
              rel={newTab ? "external nofollow noopener noreferrer" : undefined}
              target={newTab ? "_blank" : undefined}
              style={style}>
      {displayText}
    </a>
  }

  return <RouterLink className="UlLinks"
                     reloadDocument={reloadDocument}
                     replace={false}
                     style={style}
                     to={link}>
    {displayText}
  </RouterLink>
}

export default UlLink;
